import axios from 'axios'
import { jwtAuthSetup } from '@/services/httpSetup'
import { cacheAdapterEnhancer } from 'axios-extensions'

export const http = axios.create({
  /* global API_URL */
  /* eslint no-undef: "error" */
  baseURL: API_URL,
  headers: { 'Cache-Control': 'no-cache' },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false })
})

jwtAuthSetup(http)

export default {
  http
}



// WEBPACK FOOTER //
// ./src/services/http.js